export default __webpack_public_path__ + "static/media/c06a6474bd6e1cc11678c5a9a48d3d3c1602867999414.1fbefda2.webp";